import { render } from "./AddUser.vue?vue&type=template&id=3f5f5abe&scoped=true"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"

import "./AddUser.vue?vue&type=style&index=0&id=3f5f5abe&scoped=true&lang=less"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5f5abe"]])

export default __exports__